
const IMAGE_MIME_TYPES = [
    'image/png',
    'image/jpeg',
    'image/webp',
    'image/tiff',
];

const IMAGE_EXTENSIONS = [
    'png',
    'jpg',
    'webp',
    'tiff',
];

const IMAGE_MAX_SIZE = 1024 * 1024;

export {
    IMAGE_MIME_TYPES,
    IMAGE_EXTENSIONS,
    IMAGE_MAX_SIZE,
};
